const getTimeBucket = msTimeDelta => {
  if (msTimeDelta < 2000) return 'less than 2s';
  else if (msTimeDelta < 4000) return '2s - 4s';
  else if (msTimeDelta < 6000) return '4s - 6s';
  else if (msTimeDelta < 8000) return '6s - 8s';
  else if (msTimeDelta < 10000) return '8s - 10s';
  else if (msTimeDelta < 12000) return '10s - 12s';
  else if (msTimeDelta < 14000) return '12s - 14s';
  else if (msTimeDelta < 16000) return '14s - 16s';
  else if (msTimeDelta < 20000) return '16s - 20s';
  else if (msTimeDelta < 30000) return '20s - 30s';
  else if (msTimeDelta < 40000) return '30s - 40s';
  else if (msTimeDelta < 50000) return '40s - 50s';
  else if (msTimeDelta < 60000) return '50s - 60s';

  return 'greater than 1m';
};

export { getTimeBucket };
